export default function ManagementIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
        >
            <path
                d="M8.50001 15.0867C8.05335 15.0867 7.60001 14.9867 7.24668 14.78L3.58001 12.6667C2.08668 11.66 1.99335 11.5067 1.99335 9.92667V6.07333C1.99335 4.49333 2.08001 4.34 3.54668 3.34667L7.24001 1.21333C7.94001 0.806666 9.04001 0.806666 9.74001 1.21333L13.42 3.33333C14.9133 4.34 15.0067 4.49333 15.0067 6.07333V9.92C15.0067 11.5 14.92 11.6533 13.4533 12.6467L9.76001 14.78C9.40001 14.9867 8.94668 15.0867 8.50001 15.0867ZM8.50001 1.91333C8.22001 1.91333 7.94668 1.96667 7.75335 2.08L4.08668 4.2C3.00001 4.93333 3.00001 4.93333 3.00001 6.07333V9.92C3.00001 11.06 3.00001 11.06 4.11335 11.8133L7.75335 13.9133C8.14668 14.14 8.86001 14.14 9.25335 13.9133L12.92 11.7933C14 11.06 14 11.06 14 9.92V6.07333C14 4.93333 14 4.93333 12.8867 4.18L9.24668 2.08C9.05335 1.96667 8.78001 1.91333 8.50001 1.91333Z"
                fill="currentColor"
            />
            <path
                d="M8.5 10.5C7.12 10.5 6 9.38 6 8C6 6.62 7.12 5.5 8.5 5.5C9.88 5.5 11 6.62 11 8C11 9.38 9.88 10.5 8.5 10.5ZM8.5 6.5C7.67333 6.5 7 7.17333 7 8C7 8.82667 7.67333 9.5 8.5 9.5C9.32667 9.5 10 8.82667 10 8C10 7.17333 9.32667 6.5 8.5 6.5Z"
                fill="currentColor"
            />
        </svg>
    );
}
